<template>
  <popup ref="Message" :show="show">
    <div class="ui-message">
      <div class="ui-message-header">
        <img :src="`${$cdn}images/icon-story.png`" alt />
        <p>欢迎留下您的宝贵意见</p>
      </div>
      <div class="ui-message-main">
        <ul>
          <li>
            <span class="require">您的称呼</span>
            <input v-model="userName" type="text" />
          </li>
          <li>
            <span>手机号码（选填）</span>
            <input v-model="phone" type="text" />
          </li>
          <li>
            <span>邮箱地址（选填）</span>
            <input v-model="email" type="text" />
          </li>
          <li>
            <span class="require">留言内容</span>
            <textarea v-model="message" placeholder="请填写您的留言内容"></textarea>
          </li>
        </ul>
      </div>
      <div class="ui-message-footer">
        <div class="ui-button submit" @click="onOk">{{ okText }}</div>
        <div class="ui-button cancel" @click="onNo">{{ noText }}</div>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from "./popup";
export default {
  name: "ui-confirm",
  components: {
    Popup
  },
  data() {
    return {
      show: false,
      content: "",
      okText: "提交",
      noText: "取消",
      duration: 0,
      ok: null,
      no: null,
      email: "",
      message: "",
      phone: "",
      userName: ""
    };
  },
  methods: {
    async onOk() {
      let { email, message, phone, userName } = this;
      let res = await this.$http({
        method: "post",
        data: {
          email,
          message,
          phone,
          userName
        },
        url: `/api/web/save/msg`
      });


      if (res.code !== 0) {
        return this.$alert({
          title: '提示',
          tips: res.msg,
          icon:''  
        })
      }

      this.$alert();
      this.onClose();

    },
    onNo() {
      this.no && this.no();
      this.onClose();
    },
    onClose() {
      setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, this.duration);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/globalVars.less";

@liH: 50px;

textarea::placeholder {
  color: #382e2c;
}

.ui-message {
  width: 640px;
  position: relative;
  background: #f5ede2;
  padding: 20px 50px;
  .ui-message-header {
    text-align: center;
    margin: 0 auto;
    p {
      color: @theme;
      font-size: 30px;
      font-weight: bold;
    }
  }
  .ui-message-main {
    ul {
      li {
        font-size: 14px;
        color: #382e2c;
        border-bottom: 1px solid rgba(56, 46, 44, 0.16);
        height: @liH;
        line-height: @liH;
        > input {
          border: none;
          background: none;
          margin-left: 20px;
        }
        > textarea {
          border: none;
          background: none;
          height: 150px;
          width: 100%;
        }
        &:last-of-type {
          height: auto;
        }
      }
      .require {
        &::after {
          content: "*";
          color: #9d362f;
        }
      }
    }
  }
  .ui-message-footer {
    text-align: center;
    margin-top: 20px;
    .ui-button {
      display: inline-block;
      cursor: pointer;
      font-size: 14px;
      width: 104px;
      height: 38px;
      line-height: 38px;
      border: none;
      background: url("@{cdn}img_guestbook_btnbg_normal@2x.png") no-repeat
        center center;
      background-size: 100% 100%;
      color: #382e2c;
      &:first-of-type {
        margin-right: 30px;
      }
    }
    .submit {
      background: url("@{cdn}img_guestbook_btnbg_first@2x.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #f5ede2;
    }
  }
}

@media screen and (max-width: 500px) {
  .ui-message {
    width: 70%;
    border-radius: 8px;
    padding: 20px;

    .ui-message-header {
      p {
        font-size: 20px;
        margin: 10px 0;
      }
    }
    .ui-message-main {
      ul {
        li {
          textarea {
            height: 100px;
          }
        }
      }
    }
    .ui-message-footer {
      .ui-button {
        width: 93px;
        height: 34px;
      }
    }
  }
}
</style>
